module.exports = __webpack_public_path__ + "static/the-heartbeat-of-wounded-knee-ccced6b60ce40524f9f90b345c53c17c.jpg";